document.addEventListener('DOMContentLoaded', function() {
  if (typeof Swiper === 'undefined') return;

  new Swiper('.review_swiper', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 25,
    navigation: {
      nextEl: '.review-swiper-button-next.swiper-button-next',
      prevEl: '.review-swiper-button-prev.swiper-button-prev',
    }
  });
});
